/* eslint-disable */ import { attachSingleReferenceComponent, dimensionIndicatorComponent, memoEval, referenceComponent, sceneEntityPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Wall } from '../model/index.js';
export const bottomWallItemComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'BottomWallItem.$wall', true).withAlias('BottomWallItem'), Wall, 'wallId'),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'default', true).withAlias('BottomWallItem').attach(memoEval((self)=>[
            self.x,
            self.$offsetZ
        ], (x, $offsetZ)=>({
            offsetX: x,
            offsetZ: $offsetZ
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'width', true).withAlias('BottomWallItem').withFilter((self)=>({
            navigationStates: [
                'Finalize'
            ],
            active: self.$dimensionIndicatorWidthActive
        })).attach(memoEval((self)=>[
            self.$dimensionIndicatorWidthEndX,
            self.$dimensionIndicatorLabelWallFontSize
        ], ($dimensionIndicatorWidthEndX, $dimensionIndicatorLabelWallFontSize)=>({
            startX: 0,
            endX: $dimensionIndicatorWidthEndX,
            startY: 0,
            startZ: 0,
            endY: 0,
            endZ: 0,
            extrusionY: -100,
            extrusionLineDashed: true,
            arrowHeadType: 'CONE',
            labelFontSize: $dimensionIndicatorLabelWallFontSize
        })))
];

//# sourceMappingURL=bottom-wall-item.js.map